import React from 'react'

import { applyStyle, getSmartSize } from '../helpers/styles'

export const useDisabledStyle = props => {
  const { disabled } = props

  return React.useMemo(() => {
    return `
      ${applyStyle('opacity', disabled, 0.4)}
    `
  }, [disabled])
}
